import React, { useState, Component } from 'react';

import { InputText } from "primereact/inputtext";
import { AutoComplete } from 'primereact/autocomplete';
import { Dropdown } from 'primereact/dropdown';
import { Button } from "primereact/button";
import { Accordion, AccordionTab } from 'primereact/accordion';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Dialog } from 'primereact/dialog';
import { Message } from 'primereact/message';
import { Growl } from 'primereact/growl';
import { ScrollPanel } from 'primereact/scrollpanel';
import CurrencyFormat from 'react-currency-format';
import { InputTextarea } from 'primereact/inputtextarea';
import { Calendar } from 'primereact/calendar';
import { Checkbox } from 'primereact/checkbox';

import servicioReceptor from '../servicios/ServicioReceptor';
import servicioAsignacionValoresObjetos from '../servicios/ServicioAsignacionValoresObjetos';
import servicioComprobante from '../servicios/ServicioComprobante';
import servicioUsoCfdi from '../servicios/ServicioUsoCfdi';
import servicioDescargaArchivos from '../servicios/ServicioDescargaArchivos';
import servicioEnvioCorreo from '../servicios/ServicioEnvioCorreo';
import { InformacionGlobal } from './InformacionGlobal';


export default class FacturacionOtrosIngresos extends Component {
  constructor() {


    super();
    this.state = {
      erroresInformacion: {},
      informacionGlobal: {},
      setInformacionGlobal: {},
      regimenFiscales: [],
      valorencontrado: null,
      receptores: [],
      tipoComprobante: { name: 'Factura', code: 'I' },
      moneda: { name: "MXN-Peso Mexicano", code: 'MXN' },
      comprobante: { total: 0.00, subTotal: 0.00, descuento: 0.00, impuestos: { totalImpuestosTrasladados: 0.00 }, conceptos: { concepto: [] } },
      erroresRequeridos: {},
      modalProveedor: false,
      modalConceptos: false,
      conceptos: [],
      botonNuevoConcepto: false,
      botonAditarConcepto: false,
      receptor: {},
      errores: {},
      clavesProductoServicios: [],
      claveProdServ: null,
      clavesClaveUnidad: [],
      foliosFiscales: [],
      usosCfdi: [],
      erroresConcepto: {},
      concepto: {},
      formaPago: {},
      metodoPago: {},
      tiporelacion: {},
      fechaCreacion: {},
      visibleConfirmacion: false,
      responseTimbrado: {},
      envioCorreo: {},
      erroresCorreo: {},
      urlbuscarReceptorPorRfc: 'receptor/buscarReceptorPorRfc.json',
      erroresFrmDatosFiscales: {},
      timbrado: true
    }
    this.obtenerUsosCfdi();
  }

  asignarValoresObjeto = (event) => {
    if (event.target.id === "regimenFiscalReceptor" || event.target.id === "usoCfdi" || event.target.id === "correo" || event.target.id === "fecha")
      servicioAsignacionValoresObjetos.asignarAtributosObjeto(event, this);
    else
      servicioAsignacionValoresObjetos.asignarAtributosObjeto(event, this, true);

    if (event.target.id === "regimenFiscalReceptor") {
      this.obtenerUsosCfdi();
    }

  }

  asignarValoresTotales = (event) => {
    if (event.target.value.includes(",")) {
      event.target.value = event.target.value.replace(/,/g, '');
      servicioAsignacionValoresObjetos.asignarAtributosObjeto(event, this);
    } else {
      servicioAsignacionValoresObjetos.asignarAtributosObjeto(event, this);
    }


  }

  obtenerUsosCfdi = () => {
    let { receptores, receptor } = this.state;
    let objeto = {};
    objeto.rfc = receptores.rfc;
    if (receptor.regimenFiscalReceptor != null) {
      objeto.regimenFiscal = receptor.regimenFiscalReceptor.id;
    }

    servicioUsoCfdi.buscarListaUsoCfdiRegistro(objeto).then(response => {
      this.setState({ usosCfdi: response.data });
    }).catch(error => {

    });

  }

  enviarCorreo = (id) => {
    const { envioCorreo } = this.state;

    const resultadoValidacion = this.validarCampoEnvioCorrero(envioCorreo);
    this.setState({ erroresCorreo: resultadoValidacion });
    if (!Object.keys(resultadoValidacion).length) {

      servicioEnvioCorreo.envioCorreo({ correos: envioCorreo.correo, twCfdi: { id: id } }).then((response) => {
        this.growl.show({ severity: 'success', summary: 'Mensaje', detail: 'La solicitud se creo con \u00e9xito en breve te llegara la factura' });
        this.setState({ envioCorreo: {} });

      });

    }
  }

  validaFechaCreacion = (objeto) => {
    const { comprobante } = this.state;


    servicioComprobante.validarFechaCreacion({ comprobante: comprobante.fecha }).then((response) => {

    }).catch((error) => {
      this.growl.show({ severity: 'error', summary: 'Mensaje', detail: 'El servidor no responde' });
    });

  }

  validarCampoEnvioCorrero = (objeto) => {
    const erroresCorreo = {};

    var expreReg = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
    var validacionCorreo = null;

    if (objeto.correo) {
      const validacionesCorreos = objeto.correo.split(",");

      var i = 0;
      for (i = 0; i < validacionesCorreos.length; i++) {
        const valorvalidacion = expreReg.exec(validacionesCorreos[i]);
        if (valorvalidacion == null)
          validacionCorreo += "El correo : " + validacionesCorreos[i] + " no es un correo. "
      }
    }



    if (!objeto.correo)
      erroresCorreo.correo = "El correo es requerido";
    if (validacionCorreo)
      erroresCorreo.correo = "Ingrese un correo valido"
    if (validacionCorreo != null && validacionCorreo.includes("El correo :"))
      erroresCorreo.correo = validacionCorreo.replace("null", "");
    return erroresCorreo;

  }


  buscarLikeProveedor = (valor) => {
    setTimeout(() => {

      if (valor.query.length === 0) {

      }
      else {
        servicioReceptor.buscarRfc(valor.query.toUpperCase()).then((response) => {
          if (response.data === '') {
            this.growl.show({ life: 6000, severity: 'error', summary: 'Mensaje', detail: 'No existe informaci\u00f3n con los valores ingresados, tienes que crear un nuevo receptor' });
            this.setState({ valorencontrado: response.data });
          } else {
            this.growl.show({ life: 1000, severity: 'success', summary: '\u00c9xito Mensaje', detail: "Valores encontrados" });
            this.setState({ valorencontrado: response.data });
          }
        }).catch((error) => {
          this.growl.show({ severity: 'error', summary: 'Mensaje', detail: 'El servidor no responde' });
        });
      }

    }, 250);
  }

  nuevoProveedor = () => {
    this.setState({ modalProveedor: true, receptor: {} })
  }

  editarProveedor = () => {
    const { receptores } = this.state;
    if (!receptores.id) {
      this.growl.show({ severity: 'error', summary: 'Mensaje', detail: 'Por elige un proveedor' });
    } else {
      servicioReceptor.editarProveedor(receptores.id).then((response) => {
        this.setState({ receptor: response.data, modalProveedor: true });
      });
    }
  }

  guardarReceptor = () => {
    const { receptor } = this.state;
    const validacion = this.validarFormulario(receptor);
    this.setState({ erroresFrmDatosFiscales: validacion });
    if (!Object.keys(validacion).length) {
      var receptorEnvio = JSON.parse(JSON.stringify(receptor));
      servicioReceptor.guardar(receptorEnvio).then(response => {
        this.setState({ receptor: {}, modalProveedor: false });
        this.growl.show({ life: 10000, severity: 'success', summary: 'Exito', detail: 'EL receptor se creo con \u00e9xito, para utilizarlo tienes que volver a buscarlo y seleccionarlo' });
        this.obtenerResultados();
      }).catch(error => {

      });
    }

  }

  buscarLikeUUid = (valor) => {
    setTimeout(() => {

      if (valor.query.length === 0) {

      }
      else {
        servicioComprobante.buscarUuid({ uuid: valor.query.toUpperCase() }).then((response) => {
          // console.log(response.data);
          this.setState({ valorFolio: response.data });
        }).catch((error) => {
          this.growl.show({ severity: 'error', summary: 'Mensaje', detail: 'El servidor no responde' });
        });
      }



    }, 250);
  }


  existeRfc = () => {
    const { receptor } = this.state;
    servicioReceptor.rfcexiste(receptor).then((response) => {
      if (response.data) {
        this.growl.show({ life: 5000, severity: 'error', summary: 'Mensaje de error', detail: 'El rfc ' + receptor.rfc + ' ya se encuentra registrado' });
        this.setState({ receptor: { ...this.receptor, rfc: '' } });
      }
    }).catch((error) => {
      this.growl.show({ severity: 'error', summary: 'Mensaje', detail: 'El servidor no responde' });
    });
  }

  validarFormulario = () => {

    let errores = {};
    let { receptor } = this.state;
    var expreReg = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
    var validacionCorreo = null;
    if (receptor.correo) {
      const validacionesCorreos = receptor.correo.split(",");

      var i = 0;
      for (i = 0; i < validacionesCorreos.length; i++) {
        const valorvalidacion = expreReg.exec(validacionesCorreos[i]);
        if (valorvalidacion == null)
          validacionCorreo += "El correo : " + validacionesCorreos[i] + " no es un correo. "
      }
    }

    if (!receptor.rfc)
      errores.rfc = "El rfc del receptor es requerido"

    if (!receptor.correo)
      errores.correo = "El correo es requerido"
    if (validacionCorreo)
      errores.correo = "Ingrese un correo valido"
    if (validacionCorreo != null && validacionCorreo.includes("El correo :"))
      errores.correo = validacionCorreo.replace("null", "");

    if (servicioAsignacionValoresObjetos.esObjetoVacio(receptor.nombre))
      errores.nombre = "Nombre o Razón Social es requerido";
    return errores;
  }

  buscarClaveProvServ = (valor) => {
    setTimeout(() => {

      if (valor.query.length === 0) {

      } else {
        servicioComprobante.obtenerClaveProServ({ claveProdServ: valor.query }).then((response) => {
          this.setState({ claveProdServ: response.data });
        }).catch((error) => {
          this.growl.show({ severity: 'error', summary: 'Mensaje', detail: 'El servidor no responde' });
        });
      }
    }, 250);
  };

  buscarClaveUnidad = (valor) => {
    setTimeout(() => {

      if (valor.query.length === 0) {

      } else {
        servicioComprobante.ontenerClaveUnidad({ claveUnidad: valor.query }).then((response) => {
          this.setState({ clavesUnidad: response.data });
        }).catch((error) => {
          this.growl.show({ severity: 'error', summary: 'Mensaje', detail: 'El servidor no responde' });
        });
      }
    }, 250)
  }


  cargarValorClaveProvServ = (e) => {
    const { concepto } = this.state;
    if (e.value.claveProdServ) {
      concepto["claveProdServ"] = e.value.claveProdServ;
    } else {
      concepto["claveProdServ"] = e.value;
    }
  }

  cargaTipoComprobante = (e) => {
    this.setState({ tipoComprobante: e.value });
  }



  templateUsoCfdi = (option) => {
    return (
      <div className="p-clearfix">
        <span >{option.id} - {option.descripcion}</span>
      </div>
    );
  }

  nuevoConcepto = () => {
    this.setState({ concepto: {}, modalConceptos: true, botonNuevoConcepto: true });
  }

  guardarConcepto = () => {
    const { concepto, comprobante, conceptos } = this.state;
    const resultadoValidacion = this.validarFormularioConcepto(concepto);
    this.setState({ erroresConcepto: resultadoValidacion });
    if (!Object.keys(resultadoValidacion).length) {
      conceptos.push(concepto);
      servicioComprobante.guardarConcepto({ comprobante: comprobante, banobras: conceptos }).then((response) => {
        this.setState({ comprobante: response.data.comprobante, conceptos: response.data.banobras, modalConceptos: false });
      })

    }
  }

  validarFormularioConcepto = (concepto) => {
    const erroresConcepto = {};

    if (!concepto.claveProdServ)
      erroresConcepto.claveProdServ = "Clave de Producto o Servicio es requerida";
    if (!concepto.claveUnidad)
      erroresConcepto.claveUnidad = "Clave Unidad es requerida";
    if (!concepto.descripcion)
      erroresConcepto.descripcion = "Descripción es requerida";
    if (!concepto.total)
      erroresConcepto.total = "Precio Unitario es requerido";
    if (!concepto.cantidad)
      erroresConcepto.cantidad = "Cantidad es requerida";

    return erroresConcepto;
  }

  cargarValorClaveUnidad = (e) => {
    const { concepto } = this.state;
    if (e.value.claveUnidad) {
      concepto["claveUnidad"] = e.value.claveUnidad;
    } else {
      concepto["claveUnidad"] = e.value;
    }
  }

  actionOpciones = (rowData, column) => {
    return <div>
      <Button type="button" icon="pi pi-pencil" className="p-button-success"
        onClick={this.preeditarConcepto.bind(this, column.rowData)} value={rowData.id} name="objeto" tooltip="Editar">
      </Button>
      <Button type="button" icon="pi pi-trash" className="p-button-danger"
        onClick={this.preEliminarConcepto.bind(this, column.rowData)} value={rowData.id} name="objeto" tooltip="Eliminar" >
      </Button>
    </div>;
  }

  preEliminarConcepto(objeto, e) {
    const { comprobante, conceptos } = this.state;
    const index = conceptos.findIndex(concepto => concepto === objeto);
    this.setState({ conceptos: conceptos, indexConcepto: index });

    conceptos.splice(index, 1);

    servicioComprobante.guardarConcepto({ comprobante: comprobante, banobras: conceptos }).then((response) => {
      this.setState({ comprobante: response.data.comprobante, conceptos: response.data.banobras, modalConceptos: false });
    })

  }


  preeditarConcepto(objeto, e) {
    const { conceptos } = this.state;
    const index = conceptos.findIndex(concepto => concepto === objeto);
    this.setState({ concepto: objeto, modalConceptos: true, botonNuevoConcepto: false, indexConcepto: index });
  }

  editarConcepto = () => {
    const { concepto, comprobante, indexConcepto, conceptos } = this.state;
    const resultadoValidacion = this.validarFormularioConcepto(concepto);
    this.setState({ erroresConcepto: resultadoValidacion });
    if (!Object.keys(resultadoValidacion).length) {
      //console.log(concepto.unidad);
      conceptos[indexConcepto].unidad = concepto.unidad;
      conceptos[indexConcepto].claveProdServ = concepto.claveProdServ;
      conceptos[indexConcepto].claveUnidad = concepto.claveUnidad;
      conceptos[indexConcepto].descripcion = concepto.descripcion;
      conceptos[indexConcepto].valorUnitario = concepto.valorUnitario;
      conceptos[indexConcepto].cantidad = concepto.cantidad;
      conceptos[indexConcepto].descuento = concepto.descuento;

      servicioComprobante.guardarConcepto({ comprobante: comprobante, banobras: conceptos }).then((response) => {
        this.setState({ comprobante: response.data.comprobante, conceptos: response.data.banobras, modalConceptos: false });
      })
    }
  }

  preFacturar = () => {
    const { conceptos, formaPago, metodoPago, receptor, fechaCreacion, receptores, informacionGlobal } = this.state;
    receptor.nombre = receptores.nombre;
    receptor.rfc = receptores.rfc;

    const resultadoValidacion = this.validarRequeridos(formaPago, metodoPago, conceptos, receptor, fechaCreacion,informacionGlobal);
    this.setState({ erroresRequeridos: resultadoValidacion });
    console.log(resultadoValidacion);
    if (!Object.keys(resultadoValidacion).length) {

      let receptorDtoWrapper = {
        rfc: receptor.rfc,
        nombre: receptor.nombre,
        domicilioFiscalReceptor: receptor.domicilioFiscalReceptor,
        regimenFiscalReceptor: receptor.regimenFiscalReceptor.id,
        usoCFDI: receptor.usoCfdi.id
      };


      if (receptor.rfc === "XAXX010101000") {
        this.setState({ visibleConfirmacion: true });
      } else {
        servicioReceptor.validarReceptor(receptorDtoWrapper).then(response => {
          let validacionDatosFiscales = response.data.error;
          if (validacionDatosFiscales) {
            this.growl.show({ severity: 'error', summary: 'Error', detail: response.data.mensaje, life: 5000 });
          } else {
            this.setState({ visibleConfirmacion: true });
          }
        })
      }
    }
  }

  validarRequeridos = (formaPago, metodoPago, conceptos, receptor, fechaCreacion, informacionGlobal) => {
    const erroresRequeridos = {};
    const mensajesError = [];

    if (!formaPago.code) {
      erroresRequeridos.formaPago = "Forma de Pago es requerida";
      mensajesError.push({ life: 6000, severity: 'error', summary: 'Message Forma de pago', detail: erroresRequeridos.formaPago });

    }
    if (!metodoPago.code) {
      erroresRequeridos.metodoPago = "Metodo de Pago es requerida";
      mensajesError.push({ life: 6000, severity: 'error', summary: 'Message Metodo Pago', detail: erroresRequeridos.metodoPago });

    }
    if (conceptos === undefined || conceptos.length === 0) {
      erroresRequeridos.concepto = "Es nesesario agregar un producto o servicio";
      mensajesError.push({ life: 6000, severity: 'error', summary: 'Message Producto o servicio', detail: erroresRequeridos.concepto });
    }

    if (!fechaCreacion.fecha) {
      erroresRequeridos.fecha = "La fecha de creación es requerida.";
      mensajesError.push({ life: 6000, severity: 'error', summary: 'Message fecha de creacion', detail: erroresRequeridos.fecha });
    }

    if (!receptor.rfc) {
      erroresRequeridos.rfc = "El rfc del receptor es requerido"
      mensajesError.push({ life: 6000, severity: 'error', summary: 'Message rfc del receptor', detail: erroresRequeridos.rfc });
    }
    if (!receptor.usoCfdi) {
      erroresRequeridos.usoCfdi = "El uso Cfdi es requerido"
      mensajesError.push({ life: 6000, severity: 'error', summary: 'Message uso Cfdi', detail: erroresRequeridos.usoCfdi });
    }


    if (!receptor.regimenFiscalReceptor) {
      erroresRequeridos.regimenFiscalReceptor = "El regimen Fiscal Receptor es requerido"
      mensajesError.push({ life: 6000, severity: 'error', summary: 'Message uso Cfdi', detail: erroresRequeridos.regimenFiscalReceptor });
    }
    if (!receptor.correo) {
      erroresRequeridos.correo = "El correo es requerido"
      mensajesError.push({ life: 6000, severity: 'error', summary: 'Message Correo', detail: erroresRequeridos.correo });
    }

    if (servicioAsignacionValoresObjetos.esObjetoVacio(receptor.domicilioFiscalReceptor)) {
      erroresRequeridos.domicilioFiscalReceptor = "Domicilio Fiscal es requerido";
      mensajesError.push({ life: 6000, severity: 'error', summary: 'Message Domicilio Fiscal', detail: erroresRequeridos.domicilioFiscalReceptor });
    }
    if (servicioAsignacionValoresObjetos.esObjetoVacio(receptor.regimenFiscalReceptor)) {
      erroresRequeridos.regimenFiscalReceptor = "Regimen Fiscal es requerido";
      mensajesError.push({ life: 6000, severity: 'error', summary: 'Message Regimen Fiscal', detail: erroresRequeridos.regimenFiscalReceptor });
    }
    if (servicioAsignacionValoresObjetos.esObjetoVacio(receptor.nombre)) {
      erroresRequeridos.nombre = "Nombre o Razón Social es requerido";
      mensajesError.push({ life: 6000, severity: 'error', summary: 'Message Nombre o Razón Social', detail: erroresRequeridos.nombre });
    }

    if (!servicioAsignacionValoresObjetos.esObjetoVacio(receptor.rfc) && receptor.rfc === "XAXX010101000") {
      if (servicioAsignacionValoresObjetos.esObjetoVacio(informacionGlobal.periodicidad)){
        erroresRequeridos.periodicidad = "Periodicidad es requerido";
        mensajesError.push({ life: 6000, severity: 'error', summary: 'Message Periodicidad', detail: erroresRequeridos.periodicidad});

      }
      
      if (servicioAsignacionValoresObjetos.esObjetoVacio(informacionGlobal.meses)){
        erroresRequeridos.meses = "Meses es requerido";
        mensajesError.push({ life: 6000, severity: 'error', summary: 'Message Meses', detail: erroresRequeridos.meses});
      }
        
      if (servicioAsignacionValoresObjetos.esObjetoVacio(informacionGlobal.anio)){
        erroresRequeridos.anio = "Año es requerido";
        mensajesError.push({ life: 6000, severity: 'error', summary: 'Message Año', detail: erroresRequeridos.anio});
      }
       
    }

    if (Object.keys(erroresRequeridos).length) {
      this.growl.show(mensajesError);
    }
    return erroresRequeridos;
  }

  facturar = () => {
    const { erroresInformacion, regimenFiscales, comprobante, receptor, tipoComprobante, formaPago, metodoPago, moneda, conceptos, foliosFiscales, tiporelacion, fechaCreacion, informacionGlobal } = this.state;

   
    if (tiporelacion.code) {
      let uuid = foliosFiscales;
      if (typeof foliosFiscales === 'object')
        uuid = foliosFiscales.uuid;
      comprobante.cfdiRelacionados = [{ "tipoRelacion": tiporelacion.code, "cfdiRelacionado": [{ uuid: uuid }] }];
    }
    let receptorEnvio = JSON.parse(JSON.stringify(receptor));
    let usoCfdi = receptorEnvio.usoCfdi.id;
    delete receptorEnvio['usoCfdi'];
    receptorEnvio.usoCfdi = usoCfdi;
    let regimenFiscalReceptor = receptorEnvio.regimenFiscalReceptor.id;
    delete receptorEnvio['regimenFiscalReceptor'];
    receptorEnvio.regimenFiscalReceptor = regimenFiscalReceptor;
    receptorEnvio.nombre = receptorEnvio.nombre.trim();
    comprobante.fecha = new Date(fechaCreacion.fecha).getTime();
    comprobante.tipoDeComprobante = tipoComprobante.code;
    comprobante.formaPago = formaPago.code;
    comprobante.metodoPago = metodoPago.code;
    comprobante.moneda = moneda.code;
    if(!servicioAsignacionValoresObjetos.esObjetoVacio(informacionGlobal)){
      let informacionGlobalEnvio= JSON.parse(JSON.stringify(informacionGlobal));
      comprobante['informacionGlobal']={periodicidad:informacionGlobalEnvio.periodicidad.id,meses:informacionGlobalEnvio.meses.id,anio:new Date(informacionGlobalEnvio.anio).getFullYear()}
    }
    this.setState({ visibleConfirmacion: false });
    servicioComprobante.procesarcomprobante({ comprobante: comprobante, receptor: receptorEnvio, banobras: conceptos }).then((response) => {
      // console.log(response.data.error);
      if (!response.data.error) {
        this.setState({
          visibleMensajeRespuesta: true, responseTimbrado: response.data,
          comprobante: { total: 0.00, subTotal: 0.00, descuento: 0.00, impuestos: { totalImpuestosTrasladados: 0.00 } },
          emisor: '',
          formaPago: {},
          metodoPago: {},
          erroresRequeridos: {},
          erroresConcepto: {},
          errores: {},
          conceptos: [],
          tiporelacion: {},
          foliosFiscales: [],
          receptor: {},
          fechaCreacion: {},
          informacionGlobal:{}
        });
        this.setState({ timbrado: false });
        this.setState({ timbrado: true });
      } else {
        this.setState({ visibleMensajeRespuesta: true, responseTimbrado: response.data })
      }
    });

  }


  descargaArchivos = (id) => {
    servicioDescargaArchivos.descargaArchivo('documentos/cfdi/descargazip.json', { id: id });
  }

  muestramensajecorreos = (e) => {
    this.growl.show({ life: 8000, severity: 'info', summary: 'Información', detail: 'Ingresa más correos, solo separalos por una coma "," Ejemplo:(correouno,correodos)' });
  }

  impuesto_excento = (e) => {
    let { concepto } = this.state;
    concepto['impuestoExcento'] = e.checked;
    this.setState({ concepto });
  }

  actualizaReceptor = (receptor) => {
    this.setState({ receptor });
  }

  actualizaErroresFrmDatosFiscales = (erroresRequeridos) => {
    this.setState({ erroresRequeridos });
  }

  cerrarModalCliente = () => {
    let { receptor } = this.state;
    this.actualizaReceptor(receptor);
    this.setState({ modalProveedor: false, receptor: {} });
  }

  buscarReceptorPorRfc = () => {
    let { receptor, erroresFrmDatosFiscales, receptores, regimenFiscales, usosCfdi } = this.state;
    let objeto = {};
    objeto.rfc = receptores.rfc;
    erroresFrmDatosFiscales = {};
    if (receptores.rfc === 'XAXX010101000') {
      console.log("XAXX010101000");
      let regimenFiscalObjecto = { "id": "616", "descripcion": "Sin obligaciones fiscales" };
      regimenFiscales = [regimenFiscalObjecto];
      receptor['regimenFiscalReceptor'] = regimenFiscalObjecto;
      let usoCfdiObjecto = { "id": "S01", "descripcion": "Sin efectos fiscales." };
      usosCfdi = [usoCfdiObjecto];
      receptor['usoCfdi'] = usoCfdiObjecto;
      receptor['domicilioFiscalReceptor'] = "00000";
      this.setState({ receptor: receptor, regimenFiscales: regimenFiscales, usosCfdi: usosCfdi });
    } else {
      servicioReceptor.buscarReceptorPorRfcAppRegistro(objeto).then(response => {
        console.log(response.data);
        this.setState({ regimenFiscales: response.data });
        this.setState({ receptor: receptor });
        this.setState({ erroresFrmDatosFiscales: erroresFrmDatosFiscales });
      }).catch(error => {

      });
    }

  }



  render() {
    let { erroresInformacion, informacionGlobal, setInformacionGlobal, regimenFiscales, erroresFrmDatosFiscales, erroresRequeridos, envioCorreo, comprobante, usosCfdi, concepto, erroresConcepto, botonNuevoConcepto, responseTimbrado, erroresCorreo, fechaCreacion, receptores, receptor, errores } = this.state;
    const es = {
      firstDayOfWeek: 1,
      dayNames: ["domingo", "lunes", "martes", "miércoles", "jueves", "viernes", "sábado"],
      dayNamesShort: ["dom", "lun", "mar", "mié", "jue", "vie", "sáb"],
      dayNamesMin: ["D", "L", "M", "Mi", "J", "V", "S"],
      monthNames: ["enero", "febrero", "marzo", "abril", "mayo", "junio", "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"],
      monthNamesShort: ["ene", "feb", "mar", "abr", "may", "jun", "jul", "ago", "sep", "oct", "nov", "dic"]
    };
    const facturas = [
      { name: 'Factura', code: 'I' },
      { name: 'Nota de Crédito', code: 'E' },
      { name: 'Factura Global tipo G', code: 'G' },
      { name: 'Nota de crédito tipo G', code: 'NCG' }
    ];

    const formasPagos = [
      { name: '01-Efectivo', code: '01' },
      { name: '02-Cheque nominativo', code: '02' },
      { name: '03-Transferencia electrónica de fondos', code: '03' },
      { name: '04-Tarjeta de crédito', code: '04' },
      { name: '05-Monedero electrónico', code: '05' },
      { name: '06-Dinero electrónico', code: '06' },
      { name: '08-Vales de despensa', code: '07' },
      { name: '12-Dación en pago', code: '12' },
      { name: '13-Pago por subrogación', code: '13' },
      { name: '14-Pago por consignación', code: '14' },
      { name: '15-Condonación', code: '15' },
      { name: '17-Compensación', code: '17' },
      { name: '23-Novación', code: '23' },
      { name: '24-Confusión', code: '24' },
      { name: '25-Remisión de deuda', code: '25' },
      { name: '26-Prescripción o caducidad', code: '26' },
      { name: '27-A satisfacción del acreedor', code: '27' },
      { name: '28-Tarjeta de débito', code: '28' },
      { name: '29-Tarjeta de servicios', code: '29' },
      { name: '30-Aplicación de anticipos', code: '30' },
      { name: '31-Intermediario pagos', code: '31' },
      { name: '99-Por definir', code: '99' }
    ];

    const tiposRelacion = [
      { name: "01-Nota de crédito de los documentos relacionados", code: "01" },
      { name: "02-Nota de débito de los documentos relacionados", code: "02" },
      { name: "03-Devolución de mercancía sobre facturas o traslados previos", code: "03" },
      { name: "04-Sustitución de los CFDI previos", code: "04" },
      { name: "05-Traslados de mercancias facturados previamente", code: "05" },
      { name: "06-Factura generada por los traslados previos", code: "06" },
      { name: "07-CFDI por aplicación de anticipo", code: "07" },
      { name: "08-Factura generada por pagos en parcialidades", code: "08" },
      { name: "09-Factura generada por pagos diferidos", code: "09" }];

    const metodosPago = [
      { name: 'PUE-Pago en una sola exhibición', code: 'PUE' },
      { name: 'PPD-Pago en parcialidades o diferido', code: 'PPD' }
    ];

    const modenas = [
      { name: "MXN-Peso Mexicano", code: 'MXN' },
      { name: "USD-Dolar americano", code: 'USD' }];

    const botonConfirmacion = (
      <div className="p-grid">
        <div className="p-md-9 p-lg-9 p-sm-6 p-xs-6">
          <Button label="Continuar" icon="pi pi-check" onClick={this.facturar} />
        </div>
        <div className="p-md-3 p-lg-3 p-sm-6 p-xs-6">
          <Button label="Cancelar" icon="pi pi-times" className="p-button-danger" onClick={(e) => this.setState({ visibleConfirmacion: false })} />
        </div>
      </div>
    );

    const footerConceptos = (
      <div>
        {botonNuevoConcepto ? <Button label="Guardar" icon="pi pi-check" onClick={this.guardarConcepto} /> : <Button label="Editar" icon="pi pi-check" onClick={this.editarConcepto} />}
        <Button label="Cancelar" icon="pi pi-times" onClick={(e) => this.setState({ modalConceptos: false })} className="p-button-danger" />
      </div>

    );

    const botonMensajeRespuesta = (
      <div className="p-grid">
        <div className="p-md-9 p-lg-9 p-sm-6 p-xs-6">
          <Button label="Aceptar" icon="pi pi-check" onClick={(e) => this.setState({ responseTimbrado: {}, visibleMensajeRespuesta: false })} />
        </div>
      </div>
    )

    const footerCer = (
      <div>
        <Button label="Guardar" icon="pi pi-check" onClick={this.guardarReceptor} />
        <Button label="Cancelar" icon="pi pi-times" onClick={(e) => this.setState({ modalProveedor: false })} className="p-button-secondary" />
      </div>
    );

    return (<div> <Growl ref={(el) => this.growl = el}></Growl>
      <div className="content-section introduction">
        <div className="feature-intro">
          <h1>Facturación Otros Ingresos</h1>

        </div>
      </div>

      <div className="p-grid p-fluid">
        <div className="p-col-12 p-md-4">
          <h4>Busca tu cliente Receptor:</h4>
          <AutoComplete field="descripcion" id="receptores" value={this.state.receptores} suggestions={this.state.valorencontrado} completeMethod={this.buscarLikeProveedor} size={30} minLength={1}
            onChange={(e) => this.setState({ receptores: e.value })} className={erroresRequeridos.receptores ? 'p-error' : ''} onBlur={this.buscarReceptorPorRfc} />
          {erroresRequeridos.receptores ? <div> <Message severity="error" text={erroresRequeridos.receptores} /> </div> : null}
        </div>
        <div className="p-col-12 p-md-2">
          <h4><br /></h4>
          <Button className="p-button-raised p-button-info" icon="pi pi-plus" tooltip="Nuevo cliente Receptor" onClick={this.nuevoProveedor} />
          &nbsp;&nbsp;&nbsp;<Button className="p-button-raised p-button-warning" icon="pi pi-pencil" tooltip="Editar cliente Receptor" onClick={this.editarProveedor} />
        </div>
        <div className="p-col-12 p-md-4">
          <h4>Tipo de factura:</h4>
          <Dropdown id="tipofactura" value={this.state.tipoComprobante} options={facturas} onChange={this.cargaTipoComprobante} optionLabel="name" placeholder="Tipo de factura" autoWidth={false} />
        </div>
        <div className="p-col-12 p-md-12"></div>



        <div className="p-col-12 p-md-4">
          <h4>Regimen Fiscal Receptor:</h4>
          <Dropdown dataKey="id" id="regimenFiscalReceptor" name="receptor.regimenFiscalReceptor" options={regimenFiscales} value={receptor.regimenFiscalReceptor} onChange={this.asignarValoresObjeto} itemTemplate={this.templateUsoCfdi} optionLabel="descripcion" className={erroresRequeridos.regimenFiscalReceptor ? 'p-error' : ''} />
          {erroresRequeridos.regimenFiscalReceptor ? <div><br /> <Message severity="error" text={erroresRequeridos.regimenFiscalReceptor} /> </div> : null}
        </div>


        <div className="p-col-12 p-md-4">
          <h4>Uso del Cfdi:</h4>
          <Dropdown dataKey="id" id="usoCfdi" name="receptor.usoCfdi" options={usosCfdi} value={receptor.usoCfdi} onChange={this.asignarValoresObjeto} itemTemplate={this.templateUsoCfdi} optionLabel="descripcion" className={erroresRequeridos.usoCfdi ? 'p-error' : ''} />
          {erroresRequeridos.usoCfdi ? <div><br /> <Message severity="error" text={erroresRequeridos.usoCfdi} /> </div> : null}
        </div>

        <div className="p-col-12 p-md-4">
          <h4>Domicilio Fiscal Receptor (Código postal):</h4>
          <InputText id="domicilioFiscalReceptor" maxLength="5" name="receptor.domicilioFiscalReceptor" value={receptor.domicilioFiscalReceptor || ''} onChange={this.asignarValoresObjeto} className={erroresRequeridos.domicilioFiscalReceptor ? 'p-error' : ''} placeholder="Domicilio Fiscal Receptor (Código postal)" />
          {erroresRequeridos.domicilioFiscalReceptor ? <div><br /> <Message severity="error" text={erroresRequeridos.domicilioFiscalReceptor} /> </div> : null}
        </div>

        <div className="p-col-12 p-md-4">
          <h4>Correo:</h4>
          <InputText id="correo" name="receptor.correo" value={receptor.correo || ''} onChange={this.asignarValoresObjeto} className={erroresRequeridos.correo ? 'p-error' : ''} placeholder="Correo electrónico" onFocus={this.muestramensajecorreos} />
          {erroresRequeridos.correo ? <div><br /> <Message severity="error" text={erroresRequeridos.correo} /> </div> : null}
        </div>




        <div className="p-col-12 p-md-4">
          <h4>Forma de pago:</h4>
          <Dropdown id="formaPago" value={this.state.formaPago} options={formasPagos} onChange={(e) => this.setState({ formaPago: e.target.value })} optionLabel="name" placeholder="Selecciona Forma de pago" className={erroresRequeridos.formaPago ? 'p-error' : ''} autoWidth={false} />
          {erroresRequeridos.formaPago ? <div> <Message severity="error" text={erroresRequeridos.formaPago} /> </div> : null}
        </div>

        <div className="p-col-12 p-md-4">
          <h4>Método de pago:</h4>
          <Dropdown id="metodoPago" value={this.state.metodoPago} options={metodosPago} onChange={(e) => this.setState({ metodoPago: e.target.value })} optionLabel="name" placeholder="Selecciona Metodo Pago" className={erroresRequeridos.metodoPago ? 'p-error' : ''} autoWidth={false} />
          {erroresRequeridos.metodoPago ? <div> <Message severity="error" text={erroresRequeridos.metodoPago} /> </div> : null}
        </div>
        <div className="p-col-12 p-md-4">
          <h4>Fecha de creación:</h4>
          <Calendar id="fecha" name="fechaCreacion.fecha" value={fechaCreacion.fecha || ''} onChange={this.asignarValoresObjeto} className={erroresRequeridos.fecha ? 'p-error' : ''} locale={es} dateFormat="yy-mm-dd" showTime={true} showSeconds={true} />
          {erroresRequeridos.fecha ? <div> <Message severity="error" text={erroresRequeridos.fecha} /> </div> : null}
        </div>




      </div>

      {!servicioAsignacionValoresObjetos.esObjetoVacio(receptores.rfc) && receptores.rfc === 'XAXX010101000' ? <InformacionGlobal informacionGlobal={informacionGlobal} erroresInformacion={erroresRequeridos} /> : ""}




      <Accordion>
        <AccordionTab header="Cfdi relacionados">
          <div className="p-grid p-fluid">
            <div className="p-col-12 p-md-6">
              <h4>Tipo relación:</h4>
              <Dropdown id="tiporelacion" value={this.state.tiporelacion} options={tiposRelacion} onChange={(e) => this.setState({ tiporelacion: e.target.value })} optionLabel="name" placeholder="Selecciona tipo relación" autoWidth={false} />
            </div>

            <div className="p-col-12 p-md-6">
              <h4>Busca folio fiscal:</h4>
              <AutoComplete field="uuid" id="foliosFiscales" value={this.state.foliosFiscales} suggestions={this.state.valorFolio} completeMethod={this.buscarLikeUUid} size={30} minLength={1}
                onChange={(e) => this.setState({ foliosFiscales: e.value })} />
            </div>
          </div>

        </AccordionTab></Accordion>

      <Accordion>
        <AccordionTab header="Ver opciones adicionales">
          <div className="card card-w-title">
            <div className="p-grid p-fluid">
              <div className="p-col-12 p-md-4">
                <h4>Condiciones de pago:</h4>
                <InputText id="condicionespago" name="comprobante.condicionesDePago" value={comprobante.condicionesDePago || ''} onChange={this.asignarValoresObjeto} />
              </div>
              <div className="p-col-12 p-md-4">
                <h4>Moneda:</h4>
                <Dropdown id="moneda" value={this.state.moneda} options={modenas} onChange={(e) => this.setState({ moneda: e.target.value })} optionLabel="name" placeholder="Selecciona Moneda" autoWidth={false} />
              </div>
              <div className="p-col-12 p-md-4">
                <h4>Tipo de cambio:</h4>
                <InputText id="tipoCambio" name="comprobante.tipoCambio" value={comprobante.tipoCambio || ''} onChange={this.asignarValoresObjeto} />
              </div>
            </div>
          </div>
        </AccordionTab>
      </Accordion>

      <Dialog header="Nuevo Cliente" visible={this.state.modalProveedor} style={{ width: '55vw' }} onHide={(e) => this.setState({ modalProveedor: false })} footer={footerCer}>
        <ScrollPanel style={{ width: '100%', height: '200px' }}>
          <div className="p-grid p-fluid">
            <div className="p-col-12 p-md-4">
              <h4>*Rfc:</h4>
              <InputText id="rfc" name="receptor.rfc" value={receptor.rfc || ''} onChange={this.asignarValoresObjeto} className={erroresFrmDatosFiscales.rfc ? 'p-error' : ''} onBlur={this.existeRfc} />
              {erroresFrmDatosFiscales.rfc ? <div><br /> <Message severity="error" text={erroresFrmDatosFiscales.rfc} /> </div> : null}
            </div>
            <div className="p-col-12 p-md-4">
              <h4>*Nombre:</h4>
              <InputText id="nombre" name="receptor.nombre" value={receptor.nombre || ''} onChange={this.asignarValoresObjeto} className={erroresFrmDatosFiscales.nombre ? 'p-error' : ''} />
              {erroresFrmDatosFiscales.nombre ? <div><br /> <Message severity="error" text={erroresFrmDatosFiscales.nombre} /> </div> : null}
            </div>
            <div className="p-col-12 p-md-4">
              <h4>*Correo:</h4>
              <InputText id="correo" name="receptor.correo" value={receptor.correo || ''} onChange={this.asignarValoresObjeto} className={erroresFrmDatosFiscales.correo ? 'p-error' : ''} onFocus={this.muestramensajecorreos} />
              {erroresFrmDatosFiscales.correo ? <div><br /> <Message severity="error" text={erroresFrmDatosFiscales.correo} /> </div> : null}
            </div>
          </div>

        </ScrollPanel>
      </Dialog>

      <Dialog header="Nuevo producto" visible={this.state.modalConceptos} style={{ width: '68vw' }} onHide={(e) => this.setState({ modalConceptos: false })} footer={footerConceptos}>
        <ScrollPanel style={{ width: '100%', height: '400px' }}>
          <div className="p-grid p-fluid">
            <div className="p-col-12 p-md-4">
              <h4>No Identificación (Opcional):</h4>
              <InputText id="noIdentificacion" name="concepto.noIdentificacion" value={concepto.noIdentificacion || ''} onChange={this.asignarValoresObjeto} />

            </div>
            <div className="p-col-12 p-md-4">
              <h4>Clave de Producto o Servicio:</h4>
              <AutoComplete field="descripcion" name="concepto.claveProdServ" value={concepto.claveProdServ} className={erroresConcepto.claveProdServ ? 'p-error' : ''} onChange={this.cargarValorClaveProvServ}
                suggestions={this.state.claveProdServ} completeMethod={this.buscarClaveProvServ.bind(this)} tooltip="Escribe la clave a buscar" />

              {erroresConcepto.claveProdServ ? <div> <Message severity="error" text={erroresConcepto.claveProdServ} /> </div> : null}
            </div>
            <div className="p-col-12 p-md-4">
              <h4>Clave Unidad:</h4>
              <AutoComplete field="descripcion" name="concepto.claveUnidad" value={concepto.claveUnidad} className={erroresConcepto.claveUnidad ? 'p-error' : ''} onChange={this.cargarValorClaveUnidad}
                suggestions={this.state.clavesUnidad} completeMethod={this.buscarClaveUnidad.bind(this)} tooltip="Escribe la clave a buscar" />
              {erroresConcepto.claveUnidad ? <div> <Message severity="error" text={erroresConcepto.claveUnidad} /> </div> : null}

            </div>
          </div>
          <div className="p-grid p-fluid">
            <div className="p-col-12">
              <h4>Descripción:</h4>
              <InputTextarea id="descripcion" name="concepto.descripcion" value={concepto.descripcion || ''} className={erroresConcepto.descripcion ? 'p-error' : ''} onChange={this.asignarValoresObjeto} rows={1} cols={15}></InputTextarea>
              {erroresConcepto.descripcion ? <div> <Message severity="error" text={erroresConcepto.descripcion} /> </div> : null}
            </div>
          </div>
          <div className="p-grid p-fluid">
            <div className="p-col-12 p-md-4">
              <h4>Precio Total:</h4>
              <InputText id="total" keyfilter="num" name="concepto.total" value={concepto.total || ''} className={erroresConcepto.total ? 'p-error' : ''} onBlur={this.asignarValoresTotales} onChange={this.asignarValoresTotales} tooltip="Escribe la cantidad sin comas" />
              {erroresConcepto.total ? <div> <Message severity="error" text={erroresConcepto.total} /> </div> : null}
            </div>
            <div className="p-col-12 p-md-4">
              <h4>Cantidad:</h4>
              <InputText id="cantidad" keyfilter="num" name="concepto.cantidad" value={concepto.cantidad || ''} className={erroresConcepto.cantidad ? 'p-error' : ''} onChange={this.asignarValoresObjeto} />
              {erroresConcepto.cantidad ? <div> <Message severity="error" text={erroresConcepto.cantidad} /> </div> : null}
            </div>
            <div className="p-col-12 p-md-4">
              <h4>Descuento:</h4>
              <InputText id="descuento" name="concepto.descuento" keyfilter="num" value={concepto.descuento || ''} className={erroresConcepto.descuento ? 'p-error' : ''} onBlur={this.asignarValoresTotales} onChange={this.asignarValoresTotales} />
              {erroresConcepto.descuento ? <div> <Message severity="error" text={erroresConcepto.descuento} /> </div> : null}
            </div>
          </div>
          <div className="p-grid p-fluid">
            <div className="p-col-12 p-md-4">
              <h4>Unidad:</h4>
              <InputText id="unidad" name="concepto.unidad" value={concepto.unidad || ''} onChange={this.asignarValoresObjeto} suggestions={this.state.unidad} />
            </div>
            <div className="p-col-12 p-md-4">
              <h4>Impuesto</h4>
              <label htmlFor="cb1" className="p-checkbox-label">Excento</label>
              <Checkbox id="impuestoExcento" name="concepto.impuestoExcento" checked={concepto.impuestoExcento} onChange={this.impuesto_excento} />
            </div>
          </div>
        </ScrollPanel>
      </Dialog>
      <br />
      <Button label="Nuevo producto" className="p-button-info" onClick={this.nuevoConcepto} />
      <DataTable value={this.state.conceptos} responsive={true} header="Crear producto o servicio">
        <Column field="cantidad" header="Cantidad" />
        <Column field="claveProdServ" header="Clave Producto" />
        <Column field="descripcion" header="Descripción" />
        <Column field="valorUnitario" header="Precio Unitario" />
        <Column field="descuento" header="Descuento" />
        <Column header="Opciones" body={this.actionOpciones} style={{ textAlign: 'center', width: '8em' }} />
      </DataTable>
      <div className="p-grid p-fluid">
        <div className="p-col-12 p-md-2">
          <h4>Subtotal</h4>
          <p><CurrencyFormat value={comprobante.subTotal} fixedDecimalScale={true} decimalScale={2} displayType={'text'} thousandSeparator={true} prefix={'$'} decimalSeparator={'.'} /></p>
        </div>
        <div className="p-col-12 p-md-2">
          <h4>Descuento:</h4>
          <p><CurrencyFormat value={comprobante.descuento} fixedDecimalScale={true} decimalScale={2} displayType={'text'} thousandSeparator={true} prefix={'$'} /></p>
        </div>

        <div className="p-col-12 p-md-2">
          <h4>IVA</h4>
          <p><CurrencyFormat value={comprobante.impuestos.totalImpuestosTrasladados} fixedDecimalScale={true} decimalScale={2} displayType={'text'} thousandSeparator={true} prefix={'$'} /></p>

        </div>
        <div className="p-col-12 p-md-2">
          <h4>Total</h4>
          <p>
            <CurrencyFormat value={comprobante.total} fixedDecimalScale={true} decimalScale={2} displayType={'text'} thousandSeparator={true} prefix={'$'} />
          </p>
        </div>

        <div className="p-col-12 p-md-12">
          <br />
          <Button label="Facturar" className="p-button-warning" onClick={this.preFacturar} />
        </div>
      </div>
      <Dialog header="¡Confirmación!" footer={botonConfirmacion} visible={this.state.visibleConfirmacion} style={{ width: '47%' }} modal={true} onHide={() => this.setState({ visibleConfirmacion: false })}>
        <h3><b>¿Usted esta seguro que la información es correcta?</b></h3>
      </Dialog>
      <Dialog header="¡Mensaje de respuesta!" footer={botonMensajeRespuesta} visible={this.state.visibleMensajeRespuesta} style={{ width: '65%' }} modal={true} onHide={() => this.setState({ visibleMensajeRespuesta: false })}>
        <ScrollPanel style={{ width: '100%', height: '300px' }}>
          <h3><b>
            <ul>
              <li style={{ visibility: (responseTimbrado.id == null ? 'hidden' : '') }}>{responseTimbrado.uuid}</li>
              <li>{responseTimbrado.folio}</li>
              <li>{responseTimbrado.serie}</li>
              <li style={{ visibility: (responseTimbrado.id == null ? 'hidden' : '') }}><div align="center">
                <Button type="button" icon="pi pi-download" className="p-button-success"
                  onClick={(e) => this.descargaArchivos(responseTimbrado.id)} tooltip="Descargar archivos" tooltipOptions={{ position: 'top' }} /> &nbsp;&nbsp;&nbsp;
              </div></li>


            </ul>
          </b></h3>
          <div className="p-grid p-fluid" style={{ visibility: (responseTimbrado.id == null ? 'hidden' : '') }}>
            <div className="p-col-12 p-md-12">
              <h4>* Correo recomendado @gmail, @hotmail</h4>
              <InputText id="correo" name="envioCorreo.correo" value={envioCorreo.correo || ''} onChange={this.asignarValoresObjeto} onFocus={this.muestramensajecorreos}
                className={erroresCorreo.correo ? 'p-error' : ''}
              />
              {erroresCorreo.correo ? <div> <Message severity="error" text={erroresCorreo.correo} /> </div> : null}
            </div>
          </div>
          <div className="p-grid p-fluid" style={{ visibility: (responseTimbrado.id == null ? 'hidden' : '') }}>
            <div className="p-col-12 p-md-12">
              <Button label="Enviar Correo" icon="pi pi-check" onClick={(e) => this.enviarCorreo(responseTimbrado.id)} tooltip="Envío por correo">
              </Button>
            </div>
          </div>
        </ScrollPanel>
      </Dialog>
    </div>
    );
  }
}
